import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { Lightning, PauseCircle, PlayCircle } from "react-bootstrap-icons"
import { useDispatch, useSelector } from "react-redux"
import { playOrPause, prependAndPlay } from "../../stores/mediaPlayerSlice"
import { useBandPosts } from "../../hooks/useBandPosts"
import { compareByKey } from "../../util/utils"
import { Spinner } from "../../components/shared/Spinner"
import { isMobile } from "react-device-detect"

interface BandSearchResultProps {
  bandName: string
  bandCoverImageUrl?: string | null
  bandId: number
  bandPath: string
  bandLocation?: string | null
  bandTypeNice?: string | null
}

export const BandSearchResult: React.FC<BandSearchResultProps> = ({
  bandName,
  bandCoverImageUrl,
  bandId,
  bandPath,
  bandLocation,
  bandTypeNice,
}) => {
  const { isLoading, isError, data, error } = useBandPosts(bandId, "songs")
  const [albumName, setAlbumName] = useState("")

  const dispatch = useDispatch()
  const onPlayClick = (e: React.MouseEvent) => {
    if (data?.posts) {
      dispatch(prependAndPlay(sortedSongs()))
    }
  }

  const onPlayOrPauseClick = (e: React.MouseEvent) => {
    dispatch(playOrPause())
  }

  const currentMediaItem = useSelector(
    // @ts-ignore
    (state: any) => state.mediaPlayer.value.currentMediaItem,
  )
  // @ts-ignore
  const playerState = useSelector((state: any) => state.mediaPlayer.value.playerState)
  const isCurrentlyPlaying =
    playerState === "playing" && currentMediaItem?.bandId === bandId

  const sortedSongs = () => {
    if (!data?.posts) return []
    return [...data.posts]
      .sort((a, b) => compareByKey(a, b, "track_number"))
      .map((song) => ({
        ...song,
        album_name: song.album_name,
        cover_image_small: song.cover_image_small,
      }))
  }

  useEffect(() => {
    if (data && data.posts && data.posts.length > 0) {
      setAlbumName(data.posts[0].album_name)
    }
  }, [isLoading, data])

  return (
    <li className="col-span-1">
      <div>
        {bandCoverImageUrl ? (
          <div
            style={{
              backgroundColor: "black",
              backgroundImage: `url(${bandCoverImageUrl})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              aspectRatio: "16/9",
              minHeight: isMobile ? "156px" : "unset",
            }}
            className="w-full overflow-hidden"
          >
            <div
              className="w-full h-full justify-center flex items-center"
              style={{
                background: "rgb(0,0,0,0.3)",
                paddingTop: isMobile ? "36px" : "unset",
                paddingBottom: isMobile ? "36px" : "unset",
              }}
            >
              {isLoading ? (
                <Spinner />
              ) : isError ? (
                <></>
              ) : data && data.posts && data.posts.length > 0 ? (
                isCurrentlyPlaying ? (
                  <PauseCircle
                    className="text-white cursor-pointer"
                    width="50%"
                    height="50%"
                    onClick={onPlayOrPauseClick}
                  />
                ) : (
                  <PlayCircle
                    className="text-white cursor-pointer"
                    width="50%"
                    height="50%"
                    onClick={onPlayClick}
                  />
                )
              ) : null}
            </div>
          </div>
        ) : (
          <div
            className="w-full bg-black flex justify-center items-center overflow-hidden"
            style={{ aspectRatio: "16/9" }}
          >
            {isLoading ? (
              <Spinner />
            ) : isError ? (
              <>ERROR</>
            ) : data && data.posts && data.posts.length > 0 ? (
              isCurrentlyPlaying ? (
                <PauseCircle
                  className="text-white cursor-pointer"
                  width="50%"
                  height="50%"
                  onClick={onPlayOrPauseClick}
                />
              ) : (
                <PlayCircle
                  className="text-white cursor-pointer"
                  width="50%"
                  height="50%"
                  onClick={onPlayClick}
                />
              )
            ) : (
              <Lightning
                className="text-white"
                width="50%"
                height="50%"
                style={{
                  paddingTop: isMobile ? "36px" : "unset",
                  paddingBottom: isMobile ? "36px" : "unset",
                }}
              />
            )}
          </div>
        )}
      </div>
      <>
        <Link to={bandPath} title={bandName}>
          <div className="font-bold leading-tight text-black-800">
            {bandName}
          </div>
        </Link>
        {bandTypeNice && (
          <div className="font-medium leading-tight text-gray-600 text-xs uppercase">{bandTypeNice}</div>
        )}
        <Link to={bandPath} title={bandName}>
          <div className="text-gray-800 text-sm leading-tight">
            {bandLocation}
          </div>
        </Link>
      </>
    </li>
  )
}

export default BandSearchResult

